import { Component, EventEmitter, Output, Input, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

import { DevicesService } from '@services/http/devices.service';
import { StateService } from '@services/state.service';
import { CommandsService } from '@services/commands.service';
import { SettingsService } from '@services/settings.service';
import { CachedDataService } from '@services/data/cached-data.service';

import { Device } from '@models/device';

declare var swal: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'command-list',
  templateUrl: './command-list.component.html'
})

// tslint:disable-next-line:component-class-suffix
export class CommandList implements OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  public ifLoadCommand = false;
  public isOpenCtrlMenu = false;
  public arrayCommands: Array<any> = [];
  public currentDevice: Device;
  private cCode: string = null;
  @Input() getCtrlMenuStatus: boolean;
  @Output() getCtrlMenuStatusChange = new EventEmitter<boolean>();

  constructor(
    private commandsService: CommandsService,
    private devicesService: DevicesService,
    private settingsService: SettingsService,
    private cachedDataService: CachedDataService,
    public stateService: StateService) {

    this.currentDevice = this.stateService.currentDevice;
    this.cCode = this.cachedDataService.getCcode();

    this.stateService.currentDeviceObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(device => {

        this.arrayCommands = null;
        if (this.isOpenCtrlMenu) {
          this.openCtrlMenu();
        }

        this.currentDevice = device;
        this.commandsService.getCommand();
      });

    this.commandsService.getCommandsObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(arrayCommands => {
        if (this.arrayCommands) {
          if (JSON.stringify(this.arrayCommands) !== JSON.stringify(arrayCommands)) {
            this.arrayCommands = arrayCommands;
          }
        } else {
          this.arrayCommands = arrayCommands;
        }

      });

    this.commandsService.ifLoadCommandObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(value => {
        this.ifLoadCommand = value;
      });


    stateService.addCcodeEvent.subscribe(() => {
      this.cCode = this.cachedDataService.getCcode();
    });
  }

  openCtrlMenu() {

    if (this.ifLoadCommand && this.isOpenCtrlMenu) {
      return false;
    }
    this.isOpenCtrlMenu = !this.isOpenCtrlMenu;
    this.getCtrlMenuStatusChange.emit(this.isOpenCtrlMenu);

    if (this.isOpenCtrlMenu) {
      /*if open menu*/
      this.ifLoadCommand = true;
      this.commandsService.getCommand();
    }
  }

  sendCommand(command) {
    if (command.format && command.format.indexOf('ccode') >= 0 && !this.checkedCcode()) {
      swal({
        text: 'Не задан C-код',
        type: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#23518d',

        confirmButtonText: 'Задать'
      }).then((result) => {
        if (result.value) {
          this.openSettings();
        }
      });

      return false;
    }

    swal({
      text: 'Отправить команду ' + command.description + ' на сервер?',
      type: 'question',
      showCancelButton: true,
      confirmButtonColor: '#23518d',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Отправить',
      cancelButtonText: 'Отмена'
    }).then((result) => {
      if (result.value) {
        this.openCtrlMenu();
        // tslint:disable-next-line:no-shadowed-variable
        this.devicesService.sendCommand(command.id, this.currentDevice.id, this.currentDevice.provider, this.cCode).subscribe(result => {
          if (result.status === 'fail') {
            swal({
              type: 'error',
              title: 'Ошибка',
              text: 'Команда не выполнена, попробуйте позже.',
              showConfirmButton: false,
              timer: 3000,
            });
          } else {
            swal({
              type: 'success',
              text: 'Команда ' + command.description + ' отправлена на сервер',
              showConfirmButton: false,
              timer: 3000,
            });
            this.stateService.sendCommandEvent.emit();
          }

        });
      }
    });
  }

  openSettings() {
    this.settingsService.openSettingsSubject.next('command');
  }

  checkCountCommand(groups) {
    if (groups) {
      let count = 0;
      groups.map(group => {
        group.data.map(command => {
          if (command.show) {
            count++;
          }
        });
      });
      return count > 5;
    }
  }

  checkedCcode() {
    if (!this.cCode || this.cCode.length === 0 || this.cCode === 'null') {
      return false;
    } else {
      return true;
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/view/components/command-list/command-list.component.ts